import { RefObject, useEffect, useState } from 'react';

export const useSelectedTopic = (topics: string[], contentRef: RefObject<HTMLDivElement>) => {
  const [selectedTopicId, setSelectedTopicId] = useState<string>(topics[0]);

  const onTopicClick = (id: string) => {
    const target = document.getElementById(id);
    target?.scrollIntoView({
      block: 'start',
    });
    setSelectedTopicId(id);
  };

  useEffect(() => {
    // scroll toolbar to selected topic
    document
      .getElementById(`topic-${selectedTopicId}`)
      ?.scrollIntoView({ block: 'start', inline: 'center' });
  }, [selectedTopicId]);

  useEffect(() => {
    if (!contentRef.current) return;

    const headerElements = document.querySelectorAll(topics.map((id) => `#${id} > h1`).join(', '));
    const technicalDetailsElements = Array.from(headerElements);

    const selectFirstTopic = (viewportTop: number, viewportHeight: number) => {
      const viewportBottom = viewportTop + viewportHeight;

      /* Filters out all the element that are not in viewport */
      const visibleElements = technicalDetailsElements.filter((el) => {
        const element = el as HTMLElement;
        const top = element.offsetTop;
        const titleHeight = element.offsetHeight;
        const bottom = top + titleHeight;

        /* More then half of the title is visible */
        const isVisibleTop = top >= viewportTop - titleHeight / 2;
        const isVisibleBottom = bottom <= viewportBottom + titleHeight / 2;

        return isVisibleTop && isVisibleBottom;
      });

      const topElementWrapperId = visibleElements[0]?.parentElement?.id;
      /* Picks the top element */
      if (visibleElements && visibleElements.length && topElementWrapperId) {
        setSelectedTopicId(topElementWrapperId);
      }
    };

    const onScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const viewportTop = target.scrollTop;
      const viewportHeight = target.clientHeight;

      selectFirstTopic(viewportTop, viewportHeight);
    };

    selectFirstTopic(contentRef.current.scrollTop, contentRef.current.clientHeight);

    contentRef.current?.addEventListener('scroll', onScroll);

    return () => {
      contentRef.current?.removeEventListener('scroll', onScroll);
    };
  }, [contentRef, topics]);

  return {
    selectedTopicId,
    onTopicClick,
  };
};
